<script lang="ts" setup>
import { ref } from "vue";
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { Application } from "@/types/order/Application";
import WorkInfoTable from "@/views/applications/organisms/WorkInfoTable.vue";

defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
});

const isShownConfirmFollowScheduledWorkTimeModal = ref(false);
const isShownConfirmRequiredAttendanceCorrectionModal = ref(false);

const emits = defineEmits(["finishWork", "close"]);

function showConfirmFollowScheduledWorkTimeModal() {
  isShownConfirmFollowScheduledWorkTimeModal.value = true;
}
function showConfirmRequiredAttendanceCorrectionModal() {
  isShownConfirmRequiredAttendanceCorrectionModal.value = true;
}
function hideConfirmFollowScheduledWorkTimeModal() {
  isShownConfirmFollowScheduledWorkTimeModal.value = false;
}
function hideConfirmRequiredAttendanceCorrectionModal() {
  isShownConfirmRequiredAttendanceCorrectionModal.value = false;
}
function finishWork(withAttendanceCorrection: boolean) {
  emits("finishWork", withAttendanceCorrection);
}
function onClose() {
  emits("close");
}
</script>

<template>
  <BModal
    :visible="visible"
    title="残業などが発生しましたか？"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
    @hide="onClose"
  >
    <div class="px-2 pb-2">
      <p>お仕事お疲れ様でした！</p>
      <p class="text-danger">
        打刻情報を確認して、退勤後、必要に応じて勤怠変更申請を実施してください
      </p>
      <div class="my-4">
        <WorkInfoTable :application="application" />
      </div>
      <p>残業などを実施した場合</p>
      <AppButton block @click="showConfirmRequiredAttendanceCorrectionModal">
        退勤後、勤怠変更申請する
      </AppButton>
      <p class="mt-3">定刻通りの勤務であった場合</p>
      <AppButton block @click="showConfirmFollowScheduledWorkTimeModal">
        定刻で退勤する
      </AppButton>
    </div>
  </BModal>
  <BModal
    v-model="isShownConfirmRequiredAttendanceCorrectionModal"
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <div class="px-2 pb-2">
      <p>
        給与は勤怠変更申請が承認され次第、申請した内容をもとに給与額がウォレットに反映されます
      </p>
      <p>
        定刻で退勤する場合、「定刻で退勤する」を選択してください
      </p>
      <AppButton block @click="finishWork(true)" class="mt-3">
        退勤後、勤怠変更申請する
      </AppButton>
      <AppButtonOutline
        block
        @click="hideConfirmRequiredAttendanceCorrectionModal"
        class="mt-3"
      >
        キャンセル
      </AppButtonOutline>
    </div>
  </BModal>
  <BModal
    v-model="isShownConfirmFollowScheduledWorkTimeModal"
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <div class="px-2 pb-2">
      <p>
        給与は退勤後すぐにウォレットに反映されます
      </p>
      <p class="text-danger">退勤後に勤怠を修正することはできません</p>
      <p>勤怠を修正する場合、「退勤後、勤怠変更申請する」を選択してください</p>
      <AppButton block @click="finishWork(false)" class="mt-3">
        定刻で退勤する
      </AppButton>
      <AppButtonOutline
        block
        @click="hideConfirmFollowScheduledWorkTimeModal"
        class="mt-3"
      >
        キャンセル
      </AppButtonOutline>
    </div>
  </BModal>
</template>
